import { useApi } from "@/composition/useApi.js";
import { searchTerminalsFuncions } from "@/composition/searchAllTerminals.js";
export default {
  state: () => ({
    cardsAccessCards: null, // все карты доступа
    allFoldersCards: null, // все папки Карт доступа
    activeFolderCards: null, // активная папка
    isPageAdding: false, // state модалки добавления
    cardsLoader: false,
    errorTextRequest: null, // errorText
  }),
  mutations: {
    setCardsAccessCards(state, payload) {
      state.cardsAccessCards = payload;
    },
    setAllFoldersCards(state, data) {
      state.allFoldersCards = data;
      // доп обработка для работы поиска (вводит доп поля для открисовки папок)
      if (state.allFoldersCards) {
        // получение данных из файла "поиски для терминалов"
        const { visibleAllFolders } = searchTerminalsFuncions();
        // закрытие всех папок ( закрытие всех внутренних папок , отрисовка всех папок(отрисовывваем все) )
        visibleAllFolders(state.allFoldersCards, false, true);
      }
    },
    setActiveFolderCards(state, folder) {
      state.activeFolderCards = folder;
    },
    setCardsPageAdding(state, bool) {
      state.isPageAdding = bool;
    },
    setCardsErrorText(state, text) {
      state.errorTextRequest = text;
      setTimeout(() => (state.errorTextRequest = null), 3000);
    },
    // Перемещение карты доступа из папки в папку
    selectCardsCheckboxForMove(state, payload) {
      // выбор одного терминала для перемещения
      state.cardsAccessCards.find(itm => itm.id === payload.id).checkedForMove =
        payload.bool;
    },
    selectAllCardsCheckboxesForMove(state, bool) {
      // выбор всех карт доступа для перемещения
      state.cardsAccessCards.forEach(itm => {
        itm.checkedForMove = bool;
      });
    },
    removeAccessCardsFromFolder(state, arr) {
      // удаление термингала из папки после перемещения
      arr.forEach(itm => {
        state.cardsAccessCards = state.cardsAccessCards.filter(
          aCard => aCard.id !== itm,
        );
      });
    },
    setCardsLoader(state, bool) {
      state.cardsLoader = bool;
    },
  },
  actions: {
    getCardsAccessCards({ commit }, id) {
      // запрос на получение карт по id группы карт
      const { api } = useApi();
      commit("setCardsLoader", true);
      return api
        .get(`/cards/folder/${id}`)
        .then(r => {
          if (r.status == 200) commit("setCardsAccessCards", r.data);
        })
        .catch(r => {
          if (r.response.data.message)
            commit(
              "setCardsErrorText",
              Array.isArray(r.response.data.message)
                ? r.response.data.message.join(", ")
                : r.response.data.message,
            );
        })
        .finally(() => {
          commit("setCardsLoader", false);
        });
    },
    createAccessCard({ commit }, body) {
      const { api } = useApi();
      commit("setCardsLoader", true);
      return api
        .post(`/cards`, body)
        .then(r => r.status)
        .catch(r => {
          if (r.response.data.message)
            commit(
              "setCardsErrorText",
              Array.isArray(r.response.data.message)
                ? r.response.data.message.join(", ")
                : r.response.data.message,
            );
        })
        .finally(() => {
          commit("setCardsLoader", false);
        });
    },
    editAccessCard({ commit }, data) {
      const { api } = useApi();
      commit("setCardsLoader", true);
      return api
        .put(`/cards/${data.id}`, data)
        .then(r => r.status)
        .catch(r => {
          if (r.response.data.message)
            commit(
              "setCardsErrorText",
              Array.isArray(r.response.data.message)
                ? r.response.data.message.join(", ")
                : r.response.data.message,
            );
        })
        .finally(() => {
          commit("setCardsLoader", false);
        });
    },
    deleteAccessCard({ dispatch, commit }, payload) {
      const { api } = useApi();
      commit("setCardsLoader", true);
      return api
        .delete(`/cards/${payload.id}`)
        .then(r => {
          dispatch("getCardsAccessCards", payload.folderId); // обновление страницы
          return r.status;
        })
        .catch(r => {
          if (r.response.data.message)
            commit(
              "setCardsErrorText",
              Array.isArray(r.response.data.message)
                ? r.response.data.message.join(", ")
                : r.response.data.message,
            );
        })
        .finally(() => {
          commit("setCardsLoader", false);
        });
    },
    changeAccessCardsFolder({ commit }, payload) {
      const { api } = useApi();
      commit("setCardsLoader", true);
      return api
        .patch(`/cards/folder`, payload)
        .then()
        .catch(r => {
          if (r.response.data.message)
            commit(
              "setCardsErrorText",
              Array.isArray(r.response.data.message)
                ? r.response.data.message.join(", ")
                : r.response.data.message,
            );
        })
        .finally(() => {
          commit("setCardsLoader", false);
        });
    },
    monthlyBalanceTopupCards({ commit }, payload) {
      const { api } = useApi();
      commit("setCardsLoader", true);
      return api
        .post(`/cards/monthly-balance-topup`, payload)
        .then(r => r.status)
        .catch(r => {
          if (r.response.data.message)
            commit(
              "setCardsErrorText",
              Array.isArray(r.response.data.message)
                ? r.response.data.message.join(", ")
                : r.response.data.message,
            );
        })
        .finally(() => {
          commit("setCardsLoader", false);
        });
    },
  },
};
